/* eslint-disable jsx-a11y/anchor-is-valid */
import {useIntl} from 'react-intl'
import Logo from 'src/_metronic/assets/logo.png'
import Success2Img from '../assets/success-3.png'
import {Spinner} from 'react-bootstrap'

export default function Success({
  isTransactionDetailLoading,
  transactionDetail,
}: {
  isTransactionDetailLoading: boolean
  transactionDetail: any
}) {
  const intl = useIntl()

  return (
    <>
      <div className='d-flex flex-column flex-root background-gradient' id='kt_app_root'>
        <div className='flex-column flex-column-fluid' id='kt_app_page'>
          <div className='flex-column-fluid'>
            <div className='d-flex flex-column gap-10'>
              <div
                className='container-fluid pt-8'
                id='kt_app_header_container'
                style={{
                  zIndex: 1000,
                }}
              >
                <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                  <a href='/sign-in'>
                    <img alt='Logo' src={Logo} style={{width: 150}} />
                  </a>
                </div>

                <div className='mt-10'>
                  <a
                    href='/become-a-merchant/merchant-form'
                    className='d-flex align-items-center gap-3'
                  >
                    <i className='bi bi-chevron-left fs-4 text-black'></i>
                    <span className='text-black fs-3 fw-bold'>Back</span>
                  </a>
                </div>

                <div className='container'>
                  <div className='d-flex flex-column flex-root mt-10 d-flex gap-10 mb-6'>
                    <div className='w-100'>
                      <div className='card p-3 p-md-6'>
                        <div className='col-12'>
                          {isTransactionDetailLoading ? (
                            <div className='d-flex flex-column align-items-center justify-content-center h-100'>
                              <Spinner animation='border' />
                            </div>
                          ) : (
                            <>
                              <div className='row justify-content-center align-items-center mb-10'>
                                <div className='col-4'>
                                  <img
                                    src={Success2Img}
                                    alt='Success'
                                    style={{
                                      width: '250px',
                                      height: '250px',
                                    }}
                                  />
                                </div>
                                <div className='col-8'>
                                  <h1 className='mb-5 fs-2 fs-lg-2x text-black'>
                                    Transaction Summary
                                  </h1>
                                  <div
                                    style={{
                                      borderBottom: '1px solid #ccc',
                                      marginBottom: '40px',
                                      marginTop: '20px',
                                    }}
                                  >
                                    <div className='row mb-4'>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Transaction Ref. No
                                          </span>
                                          <span className='fw-semibold'>
                                            {transactionDetail?.response?.data?.referenceNumber}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Payment Status
                                          </span>
                                          <span className='fw-semibold'>
                                            {transactionDetail?.response?.data?.paymentStatus === 0
                                              ? 'Success'
                                              : 'Fail'}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='row mb-4'>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Invoice Number
                                          </span>
                                          <span className='fw-semibold'>
                                            {transactionDetail?.response?.data?.invoiceNumber}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Payment Method
                                          </span>
                                          <span className='fw-semibold'>
                                            {transactionDetail?.response?.data?.paymentMethod === 1
                                              ? 'Credit Card'
                                              : transactionDetail?.response?.data?.paymentMethod ===
                                                2
                                              ? 'Google Pay'
                                              : transactionDetail?.response?.data?.paymentMethod ===
                                                3
                                              ? 'Apple Pay'
                                              : ''}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='row mb-4'>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Amount Paid
                                          </span>
                                          <span className='fw-semibold'>
                                            AED{' '}
                                            {transactionDetail?.response?.data?.paidAmount.toFixed(
                                              2
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Date & Time of Payment
                                          </span>
                                          <span className='fw-semibold'>
                                            {new Date(
                                              transactionDetail?.response?.data?.paymentDate
                                            ).toLocaleDateString()}{' '}
                                            {new Date(
                                              transactionDetail?.response?.data?.paymentDate
                                            ).toLocaleTimeString()}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='row mb-4'>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Payment Frequency
                                          </span>
                                          <span className='fw-semibold'>
                                            {transactionDetail?.response?.data?.paymentFrequency ===
                                            1
                                              ? 'Recurring Monthly'
                                              : 'Recurring Yearly'}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <h3 className='mb-3 mt-5 fs-2 fs-lg text-black'>
                                    Order Confirmation
                                  </h3>
                                  <div style={{marginBottom: '40px'}}>
                                    <div className='row mb-4'>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Business Name
                                          </span>
                                          <span className='fw-semibold'>
                                            {transactionDetail?.response?.data?.businessName}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Subscription Plan
                                          </span>
                                          <span className='fw-semibold'>
                                            {
                                              transactionDetail?.response?.data
                                                ?.subscriptionPlanName
                                            }
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='row mb-4'>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Subscription Status
                                          </span>
                                          <span className='fw-semibold'>
                                            {transactionDetail?.response?.data
                                              ?.subscriptionStatus === 1
                                              ? 'Active'
                                              : 'Inactive'}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Plan Duration
                                          </span>
                                          <span className='fw-semibold'>
                                            {
                                              transactionDetail?.response?.data
                                                ?.subscriptionPlanDuration
                                            }{' '}
                                            {transactionDetail?.response?.data?.paymentFrequency ===
                                            1
                                              ? 'Months'
                                              : 'Years'}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='row mb-4'>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Subscription Start Date
                                          </span>
                                          <span className='fw-semibold'>
                                            {new Date(
                                              transactionDetail?.response?.data?.subscriptionStartDate
                                            ).toLocaleDateString()}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-6'>
                                        <div className='d-flex align-items-center'>
                                          <span className='text-muted' style={{minWidth: '180px'}}>
                                            Subscription End Date
                                          </span>
                                          <span className='fw-semibold'>
                                            {new Date(
                                              transactionDetail?.response?.data?.subscriptionEndDate
                                            ).toLocaleDateString()}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          <div className='row mb-4 justify-content-center align-items-center'>
                            <div className='col-4'>
                              <div className='w-100'>
                                <h3 className='text-start text-primary fs-2x mt-5'>
                                  {intl.formatMessage({
                                    id: 'LANDING.CONGRATULATIONS',
                                  })}
                                </h3>
                                <p
                                  className='text-start fs-3 text-black w-100'
                                  dangerouslySetInnerHTML={{
                                    __html: intl.formatMessage({
                                      id: 'LANDING.CONGRATULATIONS_DESC',
                                    }),
                                  }}
                                ></p>

                                <div className='d-flex justify-content-start w-50 mt-5'>
                                  <a
                                    type='button'
                                    style={{
                                      backgroundColor: '#000',
                                      color: '#fff',
                                    }}
                                    className='btn px-10 d-flex align-items-center w-100 text-center justify-content-center'
                                    href='/sign-in'
                                  >
                                    <i className='fa fa-arrow-right me-2 fs-3'></i>
                                    {intl.formatMessage({
                                      id: 'AUTH.GENERAL.SIGNIN_BUTTON',
                                    })}
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className='col-8'>
                              <div
                                style={{
                                  backgroundColor: '#eeeeee',
                                  padding: '15px',
                                  borderRadius: '8px',
                                }}
                              >
                                <h4 className='fs-6 mb-3'>Important Notes</h4>
                                <ul className='list-unstyled mb-0'>
                                  <li className='mb-2 fs-7'>
                                    • An email with your temporary password and transaction details
                                    has been sent to your registered email address. Please check
                                    your inbox or spam folder.
                                  </li>
                                  <li className='mb-2 fs-7'>
                                    • If your payment status is pending, it may take a few minutes
                                    to process. You will receive a notification once it is
                                    completed.{' '}
                                  </li>
                                  <li className='mb-2 fs-7'>
                                    • For any discrepancies or refund requests, please contact our
                                    support team at help@vasco.life with your Transaction ID.
                                  </li>
                                  <li className='mb-2 fs-7'>
                                    • Keep this confirmation for your records. If you need an
                                    invoice, you can download it from your account dashboard.
                                  </li>
                                  <li className='mb-2 fs-7'>
                                    • If this is a subscription payment, it may renew automatically.
                                    You can manage or cancel it before the next billing cycle.
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
